<div class="carte-trajet"
     [ngClass]="{ 'trajet-passe-ou-annule': trajetPasse() || trajetAnnule(), 'trajet-selectionne': trajetSelectionne() }"
     (click)="!(cliqueDesactiveSiTrajetPasse() && trajetPasse()) && enregistrerTrajetSelectionne()"
     role="button">
	<div class="info-utiles">
		@if (trajet().information) {
			<i class="pi pi-info-circle" pTooltip="{{ trajet().information }}"></i>
		}
	</div>
	<div class="trajet">
		<div class="lieux">
			<div class="lieu">
				<div class="nom-lieu" [pTooltip]="trajet().nomLieuDepart">
					{{ trajet().nomLieuDepart }}
				</div>
				<div class="heure">{{ trajet().dateDepart | date:"HH'h'mm" }}</div>
			</div>
			@if (!estAffichageMobile()) {
				<div class="divider"></div>
			}
			<div class="lieu">
				<div class="nom-lieu"
				     [pTooltip]="trajet().nomLieuArrivee">
					{{ trajet().nomLieuArrivee }}
				</div>
				<div class="heure">{{ trajet().dateArrivee | date:"HH'h'mm" }}</div>
			</div>
		</div>
		<div class="info-disponibilite">
			<app-label-statut-trajet [statut]="statutTrajet()"></app-label-statut-trajet>
			<div class="places-disponibles">
				{{
					(estAffichageMobile() ? 'GESTION_NAVETTE.TRAJETS.NOMBRE_PLACES_RESTANTES_RACCOURCI' : 'GESTION_NAVETTE.TRAJETS.NOMBRE_PLACES_RESTANTES') | translate : {
						nombre: trajet().nombrePlaces - trajet().nombreReservations,
						total: trajet().nombrePlaces
					}
				}}
			</div>
		</div>
	</div>
</div>
